import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import styles from "./style.module.scss";
import ContainerHeader from "views/components/ContainerHeader";
import { useEffect } from "react";
import { fetchDataset, fetchSavedViews } from "redux/SingleDataset/actions";
import { useParams } from "react-router";
import ViewSharingMenu from "views/components/SharingMenu/ViewSharingMenu";
import { SavedViewWithMonitoringPage } from "./SavedViewWithMonitoringPage/SavedViewWithMonitoringPage";

const SavedViewsPage = () => {
  const { viewsDatasetId } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchDataset(viewsDatasetId) as any);
    dispatch(fetchSavedViews(viewsDatasetId) as any);
    //eslint-disable-next-line
  }, [viewsDatasetId]);

  return (
    <>
      <Helmet>
        <title>Dataset Saved Views</title>
      </Helmet>
      <div className={styles.headerContainer}>
        <ContainerHeader />
      </div>
      <SavedViewWithMonitoringPage datasetId={viewsDatasetId!} />
      <ViewSharingMenu />
    </>
  );
};

export default SavedViewsPage;
